import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { Box, Card, CardActionArea, CardContent, CardMedia, LinearProgress, Paper, Typography, useTheme } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useAuthContext } from "../../shered/contexts";
import { EstatisticasService, IDadosHistoricoVitorias, IListaDadosGaleriaGM } from "../../shered/services/api/estatisticas/EstatisticasService";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";



export const DetalheDeGaleriaGM: React.FC = () => {
    const user = CookieService.get("access_user");
    const { id } = useParams<"id">(); //Recebe Parametro de tipagem
    const [isLoading, setIsLoadig] = useState(false);
    const [dados, setDados] = useState<IListaDadosGaleriaGM>();
    const { logout } = useAuthContext();
    const [nomeUsuario, setNomeUsuario] = useState("");
    const navigate = useNavigate();
    const { formRef } = useVForm();
    const [historicoTituloLiga, setHistoricoTituloLiga] = useState<IDadosHistoricoVitorias[]>([]);
    const [historicoTituloConferencia, setHistoricoTituloConferencia] = useState<IDadosHistoricoVitorias[]>([]);
    const [historicoTituloDivisao, setHistoricoTituloDivisao] = useState<IDadosHistoricoVitorias[]>([]);
    const [historicoTituloCopinha, setHistoricoTituloCopinha] = useState<IDadosHistoricoVitorias[]>([]);
    const [imagemTrofelConferencia, setImagemTrofelConferencia] = useState<any | null>("../../../../newConferencia.png");
    const [imagemTrofelDivisao, setImagemTrofelDivisao] = useState<any | null>("../../../../newDivisao.png");
    const [imagemTrofelLiga, setImagemTrofelLiga] = useState<any | null>("../../../../newLiga.png");
    const [imagemTrofelCopinha, setImagemTrofelCopinha] = useState<any | null>("../../../../newCopinha.png");
    const [semImagem, setSemImagem] = useState<any>("../../../../semimagem.png");

    useEffect(() => {

        if (id !== null && id !== undefined && id !== "") {
            const resultCrypt = UtilidadeService.decrypt(id.toString());
            setIsLoadig(true);
            EstatisticasService.getGaleriaGM(Number(resultCrypt))
                .then((result) => {
                    setIsLoadig(false);
                    const dados = result.dado;
                    setDados(dados);
                    setHistoricoTituloConferencia(dados.historico_Conferencia.length > 0 ? dados.historico_Conferencia : []);
                    setHistoricoTituloDivisao(dados.historico_Divisao.length > 0 ? dados.historico_Divisao : []);
                    setHistoricoTituloLiga(dados.historico_Liga.length > 0 ? dados.historico_Liga : []);
                    setHistoricoTituloCopinha(dados.historico_Copinha !== undefined && dados.historico_Copinha.length > 0 ? dados.historico_Copinha : []);
                })
                .catch((errors) => {
                    if (errors.response.data.statusHTTP === 401) {
                        logout();
                        alert("Sessão expirada!")
                        navigate(0);
                        return;
                    }
                });

        }
        setIsLoadig(false);
    }, [id]);

    const handleSave = async (dados: any) => {
        console.log(dados);
    }

    return (
        <LayoutBaseDePagina titulo={`Galeria de Troféus ${nomeUsuario}`}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmVoltar={() => navigate("/liga/estatisticas/trofeusgm")}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2}>
                        {isLoading && (<Grid >
                            <LinearProgress variant="indeterminate" />
                        </Grid>)}
                        <Grid container size={{ xs: 12 }} display={"flex"} justifyContent={"center"} padding={2}>
                            <Box width="100%" display="flex" justifyContent={"center"} padding={2} boxShadow={2} >
                                <Grid container size={{ xs: 12 }}>
                                    <Grid size={{ xs: UtilidadeService.isMobile() ? 3 : 2 }} alignContent={"center"}>
                                        <Typography variant="h6" padding={2}>
                                            <img alt={"foto"} src={dados?.foto != null ? dados?.foto : semImagem} width={UtilidadeService.isMobile() ? 45 : 90} height={UtilidadeService.isMobile() ? 45 : 90} />
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: UtilidadeService.isMobile() ? 9 : 10 }} alignSelf={"center"} >
                                        <Typography variant={UtilidadeService.isMobile() ? "h6" : "h5"} >
                                            {dados?.nome}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid container size={{ xs: 12 }}>
                            <Grid size={{ xs: 12 }} display={"flex"} flexDirection={"row"} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20, fontWeight: "bold" }} alignSelf={"center"} >Títulos Liga</Typography>
                            </Grid>
                            {!isLoading && historicoTituloLiga.length > 0 ? (historicoTituloLiga.map(liga => (
                                <Grid key={liga.codigo} size={{ xs: 4, sm: 1, md: 1 }} minWidth={UtilidadeService.isMobile() ? "90px" : "110px"} display={"flex"} justifyContent={"center"} textAlign={"center"}>
                                    <Card key={liga.codigo}
                                    //onClick={() => { localStorage.setItem("paginaVoltar", "d"); navigate(`/liga/${liga.codigo}`); localStorage.setItem("@codigoLiga", liga.codigo.toString()); }}
                                    >
                                        <CardActionArea>
                                            <CardMedia
                                                component="img"
                                                alt="green iguana"
                                                height={UtilidadeService.isMobile() ? 40 : 70}
                                                image={imagemTrofelLiga}
                                                style={{ paddingTop: "8px", objectFit: "contain" }}
                                                key={liga.codigo}

                                            />
                                            <CardContent sx={{ padding: 1, paddingBottom: 1, justifyContent: "center", alignItems: "stretch", }} >
                                                <Grid container size={{ xs: 12 }} sx={{ justifyContent: "center", alignItems: "stretch", minHeight: UtilidadeService.isMobile() ? "130px" : "177px" }} >
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto", fontWeight: "bold" }}>
                                                            {liga.descricao_Temporada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {liga.codigo_Liga} - {liga.nome_Liga}
                                                        </Typography>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {liga.nome_Franquia}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ display: "flex", alignSelf: "end", justifyContent: "center" }}>
                                                        <Typography variant="body2" style={{ paddingTop: "8px", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            <img src={liga.logo_Franquia} width={UtilidadeService.isMobile() ? 40 : 60} height={UtilidadeService.isMobile() ? 40 : 60} />
                                                        </Typography>
                                                    </Grid>
                                                    {/* </Box> */}
                                                </Grid>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Sem título</Typography>
                                </Grid>
                            }
                        </Grid>
                        <Grid size={{ xs: 12 }} padding={0}>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12 }}>
                            <Grid size={{ xs: 12 }} display={"flex"} flexDirection={"row"} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20, fontWeight: "bold" }} alignSelf={"center"}>Títulos Conferência</Typography>
                            </Grid>
                            {!isLoading && historicoTituloConferencia.length > 0 ? (historicoTituloConferencia.map(liga => (
                                <Grid key={liga.codigo} size={{ xs: 4, sm: 1, md: 1 }} minWidth={UtilidadeService.isMobile() ? "90px" : "110px"} display={"flex"} justifyContent={"center"} textAlign={"center"}>
                                    <Card key={liga.codigo} style={{ width: "100%" }}
                                    //onClick={() => { localStorage.setItem("paginaVoltar", "d"); navigate(`/liga/${liga.codigo}`); localStorage.setItem("@codigoLiga", liga.codigo.toString()); }}
                                    >
                                        <CardActionArea>
                                            <CardMedia
                                                component="img"
                                                alt="green iguana"
                                                height={UtilidadeService.isMobile() ? 45 : 75}
                                                style={{ paddingTop: "4px", objectFit: "contain" }}
                                                image={imagemTrofelConferencia}
                                                key={liga.codigo}

                                            />
                                            <CardContent sx={{ padding: 1, paddingBottom: 1, justifyContent: "center", alignItems: "stretch", }} >
                                                <Grid container size={{ xs: 12 }} sx={{ justifyContent: "center", alignItems: "stretch", minHeight: UtilidadeService.isMobile() ? "130px" : "177px" }} >
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto", fontWeight: "bold" }}>
                                                            {liga.descricao_Temporada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {liga.codigo_Liga} - {liga.nome_Liga}
                                                        </Typography>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {liga.nome_Franquia}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ display: "flex", alignSelf: "end", justifyContent: "center" }}>
                                                        <Typography variant="body2" style={{ paddingTop: "8px", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            <img src={liga.logo_Franquia} width={UtilidadeService.isMobile() ? 40 : 60} height={UtilidadeService.isMobile() ? 40 : 60} />
                                                        </Typography>
                                                    </Grid>
                                                    {/* </Box> */}
                                                </Grid>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Sem título</Typography>
                                </Grid>
                            }
                        </Grid>
                        <Grid size={{ xs: 12 }} padding={0}>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12 }}>
                            <Grid container size={{ xs: 12 }} display={"flex"} flexDirection={"row"} >
                                <Typography variant="h6"
                                    style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20, fontWeight: "bold" }}
                                    alignSelf={"center"}
                                >
                                    Títulos Divisão
                                </Typography>
                            </Grid>
                            {!isLoading && historicoTituloDivisao.length > 0 ? (historicoTituloDivisao.map(liga => (
                                <Grid key={liga.codigo} size={{ xs: 4, sm: 1, md: 1 }}
                                    minWidth={UtilidadeService.isMobile() ? "90px" : "110px"}
                                    display={"flex"}
                                    justifyContent={"center"}
                                    textAlign={"center"}
                                >
                                    <Card key={liga.codigo}
                                    //onClick={() => { localStorage.setItem("paginaVoltar", "d"); navigate(`/liga/${liga.codigo}`); localStorage.setItem("@codigoLiga", liga.codigo.toString()); }}
                                    >
                                        <CardActionArea>
                                            <CardMedia
                                                component="img"
                                                alt="green iguana"
                                                height={UtilidadeService.isMobile() ? 40 : 70}
                                                style={{ paddingTop: "8px", objectFit: "contain" }}
                                                image={imagemTrofelDivisao}
                                                key={liga.codigo}
                                            />
                                            <CardContent sx={{ padding: 1, paddingBottom: 1, justifyContent: "center", alignItems: "stretch", }} >
                                                <Grid container size={{ xs: 12 }} sx={{ justifyContent: "center", alignItems: "stretch", minHeight: UtilidadeService.isMobile() ? "130px" : "177px" }} >
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto", fontWeight: "bold" }}>
                                                            {liga.descricao_Temporada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {liga.codigo_Liga} - {liga.nome_Liga}
                                                        </Typography>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {liga.nome_Franquia}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ display: "flex", alignSelf: "end", justifyContent: "center" }}>
                                                        <Typography variant="body2" style={{ paddingTop: "8px", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            <img src={liga.logo_Franquia} width={UtilidadeService.isMobile() ? 40 : 60} height={UtilidadeService.isMobile() ? 40 : 60} />
                                                        </Typography>
                                                    </Grid>
                                                </Grid>

                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Sem título</Typography>
                                </Grid>
                            }
                        </Grid>
                        <Grid size={{ xs: 12 }} padding={0}>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12 }}>
                            <Grid container size={{ xs: 12 }} display={"flex"} flexDirection={"row"} >
                                <Typography variant="h6"
                                    style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20, fontWeight: "bold" }}
                                    alignSelf={"center"}
                                >
                                    Títulos Copinha
                                </Typography>
                            </Grid>
                            {!isLoading && historicoTituloCopinha.length > 0 ? (historicoTituloCopinha.map(cop => (
                                <Grid key={cop.codigo} size={{ xs: 4, sm: 1, md: 1 }}
                                    minWidth={UtilidadeService.isMobile() ? "90px" : "110px"}
                                    display={"flex"}
                                    justifyContent={"center"}
                                    textAlign={"center"}
                                >
                                    <Card key={cop.codigo}
                                    //onClick={() => { localStorage.setItem("paginaVoltar", "d"); navigate(`/liga/${liga.codigo}`); localStorage.setItem("@codigoLiga", liga.codigo.toString()); }}
                                    >
                                        <CardActionArea>
                                            <CardMedia
                                                component="img"
                                                alt={`copinha_${cop.codigo}`}
                                                height={UtilidadeService.isMobile() ? 40 : 70}
                                                style={{ paddingTop: "8px", objectFit: "contain" }}
                                                image={imagemTrofelCopinha}
                                                key={cop.codigo}
                                            />
                                            <CardContent sx={{ padding: 1, paddingBottom: 1, justifyContent: "center", alignItems: "stretch", }} >
                                                <Grid container size={{ xs: 12 }} sx={{ justifyContent: "center", alignItems: "stretch", minHeight: UtilidadeService.isMobile() ? "130px" : "177px" }} >
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto", fontWeight: "bold" }}>
                                                            {cop.descricao_Temporada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }}>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {cop.codigo_Liga} - {cop.nome_Liga}
                                                        </Typography>
                                                        <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {cop.nome_Franquia}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ display: "flex", alignSelf: "end", justifyContent: "center" }}>
                                                        <Typography variant="body2" style={{ paddingTop: "8px", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            <img src={cop.logo_Franquia} width={UtilidadeService.isMobile() ? 40 : 60} height={UtilidadeService.isMobile() ? 40 : 60} />
                                                        </Typography>
                                                    </Grid>
                                                </Grid>

                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )))
                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Sem título</Typography>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina>
    );
};